<template>
    <router-view class="reports-dashboards-module" />
</template>
<script>
import { noMarginMixin } from '@/mixins'
export default {
    name: 'Reports',
    mixins: [noMarginMixin],
    computed: {
        currentUser() {
            return this.$store.state.currentUser.user
        },
        isAdmin() {
            const allowedRoles = ['administrator', 'local_administrator', 'god']
            return (
                allowedRoles.includes(this.currentUser.role.name) ||
                this.currentUser.is_values_master
            )
        },
    },
    mounted() {
        this.checkIfUserCanViewReportsPage()
    },
    methods: {
        checkIfUserCanViewReportsPage() {
            if (!(this.isAdmin && this.currentUser.has_value)) {
                this.$route.go(-1)
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.reports-dashboards-module {
    font-family: Roboto;
    animation-name: fadeIn;
    animation-duration: 0.4s;
}
</style>
